
import React, {useEffect,useState} from 'react'

  const packages = [
    {
      duration: "7 Days",
      oneTime: "₹149/walk",
      twiceADay: "₹199/walk",
    },
    {
      duration: "15 Days",
      oneTime: "₹135/walk",
      twiceADay: "₹180/walk",
    },
    {
      duration: "30 Days",
      oneTime: "₹125/walk",
      twiceADay: "₹150/walk",
    },
  ];
  const faqData = [
    {
      question: "How can I schedule a dog walk?",
      answer: "It's easy! Just download our app or through our website, and you can schedule a dog walking service. You can also reach out to us at 1800-120-5042 and we'll work with you to set up a scheduled walk that works best for you and your dog.",
    },
    {
      question: "What if my dog has special needs or behavioral issues?",
      answer: "We understand that some dogs have special needs or behavioral concerns. Please reach out to us with your dog's requirements, and we'll ensure that the right walker with experience is assigned to your dog.",
    },
    {
      question: "How many dogs can a dog walker handle?",
      answer: "Our walkers can handle up to 3 dogs at a time, ensuring each dog receives individual attention and care during the walk.",
    },
    {
      question: "Will my dog have the same walker every time?",
      answer: "We strive to provide consistency for your dog. However, in some cases, another walker may be assigned if the primary walker is unavailable. Rest assured, all of our walkers are trained and professional.",
    },
    {
      question: "How long are the dog walks?",
      answer: "We offer dog walks of 25 minutes and 60 minutes, depending on your preference. You can select the duration that best suits your dog’s needs when booking.",
    },
  ];
  const cities = [
    { name: "Ahmedabad", icon: "🦮" },
    { name: "Alwar", icon: "🏙️" },
    { name: "Bengaluru", icon: "🐕" },
    { name: "Chennai", icon: "🌆" },
    { name: "Delhi", icon: "🏙️" },
    { name: "Ghaziabad", icon: "🌇" },
    { name: "Greater Noida", icon: "🏢" },
    { name: "Gurgaon", icon: "🏙️" },
    { name: "Hyderabad", icon: "🌆" },
    { name: "Jaipur", icon: "🏰" },
    { name: "Kolkata", icon: "🌆" },
    { name: "Mumbai", icon: "🌇" },
    { name: "Mysore", icon: "🏞️" },
    { name: "Noida", icon: "🏙️" },
    { name: "Pune", icon: "🌳" },
    { name: "Vizag", icon: "🏖️" }
  ];
const DogWalking = () => {
    const walkSteps = [
        {
          icon: "//dm6g3jbka53hp.cloudfront.net/static-images/dog-walking_steps-section_calender-image.svg", 
          title: "Set your schedule",
          description: "Scheduled dog walks, select the date and time that best suits your dog's needs.",
        },
        {
          icon: "//dm6g3jbka53hp.cloudfront.net/static-images/dog-walking_steps-section_walkinfo-icon.svg",
          title: "Select walk info",
          description: "Choose between a 25-minute, or 60-minute GPS-tracked walks for your dog.",
        },
        {
          icon: "//dm6g3jbka53hp.cloudfront.net/static-images/dog-walking_steps-section_dog-walking-icon.svg", 
          title: "Follow all",
          description: "Get live updates about your dog's walks such as pictures and video updates on the path.",
        },
      ];
      const whyUseAdoptAPet = [
        {
          icon: "💳", 
          title: "Cashless Payments",
          description:
            "Pay securely online—no cash or checks required. Your dog walker automatically gets paid after the completion of their walk.",
        },
        {
          icon: "✅", 
          title: "Adopt a Pet Guarantee",
          description:
            "Safety is at the heart of what we do. Every booking made through Adopt a Pet is backed by the Adopt a Pet Guarantee.",
        },
        {
          icon: "💬", 
          title: "Booking Protection",
          description:
            "It doesn't happen often, but if your dog walker has to cancel at the last minute, we’ll work with you to find another one.",
        },
        {
          icon: "📞",
          title: "24X7 World-class Support",
          description:
            "We’re pet-friendly, knowledgeable, and total pet fanatics. You can get in touch with us anytime.",
        },
      ];
      const dogWalkingUpdates = [
        "Start and stop time of walks",
        "Map of their walk with total distance",
        "Pee and poo breaks",
        "Cute walking photos",
        "Personalized notifications",
      ];
      const reviews = [
        {
          name: "Jagrati",
          location: "Bangalore",
          rating: 5,
          image: "//dm6g3jbka53hp.cloudfront.net/static-images/download-app-page_reviews-section_reviewer-image1.png", 
          text: "ThePetNest! gives me great peace of mind while I am busy. I get to the minute potty and poo information at the end of the walk. Thank you ThePetNest!",
        },
        {
          name: "Ramandeep",
          location: "Noida",
          rating: 5,
          image: "//dm6g3jbka53hp.cloudfront.net/static-images/download-app-page_reviews-section_reviewer-image1.png",
          text: "This is the best thing for my blue and me. He loves getting to meet new people and going on long walks. I'm not worried about him not getting enough exercise!",
        },
        {
          name: "Chitr Kapoor",
          location: "Pune",
          rating: 5,
          image: "//dm6g3jbka53hp.cloudfront.net/static-images/review-pet-d1.png", 
          text: "Great app for hiring a dog walker! I love that I can track where my dog is, how many km she walked, when she potties, etc. She comes back very happy!",
        },
        {
          name: "Khyati Singh",
          location: "Delhi",
          rating: 5,
          image: "//dm6g3jbka53hp.cloudfront.net/static-images/download-app-page_reviews-section_reviewer-image4.png",
          text: "I've been using the ThePetNest app! for about 6 months and love the convenience of being able to have someone take care of my pup when I'm busy.",
        },
        {
          name: "Pankaj Tatwavedi",
          location: "Mumbai",
          rating: 5,
          image: "//dm6g3jbka53hp.cloudfront.net/static-images/download-app-page_reviews-section_reviewer-image1.png", 
          text: "What a great experience! I'm sure Oliver was happy to go outside and stretch her legs.",
        },
        {
          name: "Naveen",
          location: "Chandigarh",
          rating: 5,
          image: "//dm6g3jbka53hp.cloudfront.net/static-images/download-app-page_reviews-section_reviewer-image1.png",
          text: "ThePetNest app is great for times I can't get home to walk my dog. The walkers leave a nice recap of my dog's behavior! Best of all, my dog loves meeting new people who come walk him!",
        },
      ];
      
      const [visibleReviews, setVisibleReviews] = useState([]);

  useEffect(() => {
    let index = 0;

    const updateReviews = () => {
      setVisibleReviews(reviews.slice(index, index + 3));
      index = (index + 3) % reviews.length;
    };

    updateReviews(); 
    const interval = setInterval(updateReviews, 6000);

    return () => clearInterval(interval);
  }, []);  const [activeQuestion, setActiveQuestion] = useState(null);

  const toggleAnswer = (index) => {
    setActiveQuestion(activeQuestion === index ? null : index);
  };

    return (
        <div>
            <div style={{ backgroundImage: 'url(./dogwalking.jpeg)', height: "1000px", width: "", }}>
                <div>
                    <p className='text-6xl text-white font-bold pt-32 pl-16'>Book trusted, local,
                    <br /> 5-star dog walkers
                        in your <br /> neighborhood</p>
                    <p className='text-white text-2xl pl-16 pt-8'>Personalized care for your dog</p>
                    <button className='bg-orange-500 w-52 h-12 rounded-lg ml-16 mt-8 text-white font-bold'>Book a Dog Walk</button>
                </div>

            </div>
            <div className="p-6 max-w-5xl mx-auto">
      <h2 className="text-center font-bold text-3xl text-gray-800 mb-8">
        How to book a dog walk with Adopt a Pet!
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {walkSteps.map((step, index) => (
          <div
            key={index}
            className="flex flex-col items-center bg-white shadow-lg rounded-lg p-6 hover:shadow-xl transition-shadow"
          >
            <div className="flex items-center justify-center bg-orange-100 rounded-full h-16 w-16 mb-4">
                <img src={step.icon} alt="" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              {step.title}
            </h3>
            <p className="text-gray-600 text-center">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
    <div className="p-6  mx-auto bg-yellow-50">
      <h2 className="text-center font-bold text-3xl text-gray-800 mb-8">
        Why use Adopt a Pet! to get your dog walked?
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-6">
        {whyUseAdoptAPet.map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center  shadow-lg rounded-lg p-6 hover:shadow-xl bg-white "
          >
            <div className="flex items-center justify-center bg-orange-100 rounded-full h-16 w-16 mb-4">
                {/* <img src={item.icon} alt="" /> */}
              <span className="text-orange-600 text-3xl">{item.icon}</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              {item.title}
            </h3>
            <p className="text-gray-600 text-center">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
    <div className="p-6 max-w-5xl mx-auto flex flex-col lg:flex-row items-center gap-8">
      <div className="flex-1">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">
          Get Detailed Dog Walking Updates
        </h2>
        <p className="text-gray-600 mb-6">
          With the Adopt a Pet app, get comprehensive details of your dog walking from your walker that includes:
        </p>
        <ul className="space-y-3">
          {dogWalkingUpdates.map((item, index) => (
            <li key={index} className="flex items-start">
              <span className="text-orange-600 text-2xl mr-3">🔸</span>
              <p className="text-gray-700">{item}</p>
            </li>
          ))}
        </ul>
      </div>

      <div className="flex-1 ml-20">
        <img
          src="//dm6g3jbka53hp.cloudfront.net/static-images/download-app-page_reviews-section_app-walk-updates-mockups.svg"
          alt="App Mockup"
          className="rounded-lg shadow-lg"
        />
      </div>
    </div>
    <div className="p-6  mx-auto h-[600px] bg-orange-500">
      <h2 className="text-center text-3xl font-bold text-white mb-4 mt-14">
        Join the thousands of pet parents already saving money with Adopt a Pet
      </h2>
      <p className="text-center text-white mb-6">
        <span className="flex justify-center text-orange-500 text-xl space-x-1">
          {"⭐".repeat(5)}
        </span>
        <span className="text-white font-medium">4.9/5 · 1124+ reviews</span>
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {visibleReviews.map((review, index) => (
          <div
          key={index}
          className="border border-gray-200 rounded-lg p-4 shadow-sm bg-white"
        >
            <div className="flex items-center mb-4">
              <img
                src={review.image}
                alt={review.name}
                className="w-12 h-12 rounded-full mr-3"
              />
              <div>
                <h3 className="font-bold text-gray-800">{review.name}</h3>
                <p className="text-sm text-gray-600">{review.location}</p>
              </div>
            </div>
            <p className="text-yellow-500 mb-2">
              {"⭐".repeat(review.rating)}
            </p>
            <p className="text-gray-700">{review.text}</p>
          </div>
        ))}
      </div>
    </div>
    <div className="p-6 max-w-9xl mx-auto bg-gradient-to-r from-blue-100 via-blue-300 to-blue-500 rounded-lg shadow-lg">
      <h2 className="text-center font-extrabold text-4xl text-white mb-10 tracking-wide">
        Dog Walking Packages
      </h2>

      <div className="flex justify-center gap-12 mb-10">
        <div className="flex flex-col items-center bg-white p-6 shadow-xl rounded-lg w-56">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">Frequency</h3>
          <div className="space-y-4 text-lg text-gray-700">
            <div className="flex items-center space-x-2">
              <input type="radio" id="oneTime" name="frequency" value="One Time" />
              <label htmlFor="oneTime">One Time a Day</label>
            </div>
            <div className="flex items-center space-x-2">
              <input type="radio" id="twiceADay" name="frequency" value="Twice a Day" />
              <label htmlFor="twiceADay">Twice a Day</label>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center bg-white p-6 shadow-xl rounded-lg w-56">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">Duration</h3>
          <div className="space-y-4 text-lg text-gray-700">
            <div className="flex items-center space-x-2">
              <input type="radio" id="twentyFiveMin" name="duration" value="25 Minutes" />
              <label htmlFor="twentyFiveMin">25 Minutes</label>
            </div>
            <div className="flex items-center space-x-2">
              <input type="radio" id="sixtyMin" name="duration" value="60 Minutes" />
              <label htmlFor="sixtyMin">60 Minutes</label>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {packages.map((pkg, index) => (
          <div
            key={index}
            className="flex flex-col items-center bg-white shadow-xl rounded-lg p-6 transition-all hover:scale-105 hover:shadow-2xl transform duration-300"
          >
            <h3 className="text-2xl font-bold text-gray-800 mb-4">{pkg.duration}</h3>
            <div className="w-full border-t-4 border-blue-500 my-4"></div>
            <div className="space-y-6 text-lg text-gray-700">
              <div className="flex items-center space-x-4">
                <span className="text-blue-500 text-2xl">💰</span>
                <p className="font-medium">Starting from: <strong>{pkg.startingPrice}</strong></p>
              </div>
              <div className="flex items-center space-x-4">
                <span className="text-blue-500 text-2xl">💵</span>
                <p className="font-medium">Price/Walk: <strong>{pkg.pricePerWalk}</strong></p>
              </div>
            </div>
            <button className="mt-6 bg-blue-500 text-white py-2 px-6 rounded-full text-lg font-semibold transition-transform hover:scale-110">
              Book Now
            </button>
          </div>
        ))}
      </div>
    </div>
    <div className="flex flex-col-reverse lg:flex-row items-center justify-between p-10 bg-gray-100 rounded-lg shadow-xl">
      <div className="flex-1 space-y-6 max-w-2xl text-center lg:text-left">
        <h2 className="text-4xl font-extrabold text-gray-800">
          When nature calls, dog walkers on Adopt a Pet answer
        </h2>
        <p className="text-xl text-gray-700 mt-4">
          You can't always predict a super busy day, but you can anticipate your dog's needs. Instead of rushing home, book a dog walker to give your dog a 25- or 60-minute dog walk.
        </p>
        <p className="text-lg text-gray-600 mt-4">
          Our team of experienced and caring dog walkers is here to ensure that your dog gets the exercise and socialization they need to stay healthy and happy.
        </p>
        <p className="text-lg text-gray-600 mt-4">
          Dog Walkers are also trained in basic pet first aid and can handle any unexpected situations that may arise. We pride ourselves on providing reliable, trustworthy, and professional service.
        </p>
        
      </div>

      <div className="flex-1 max-w-xs sm:max-w-sm lg:max-w-md xl:max-w-lg">
        <img
          src="//dm6g3jbka53hp.cloudfront.net/static-images/dog-walking_whychooseus-section_dog-imagee.svg" 
          alt="Dog Walking"
          className="rounded-lg shadow-lg"
        />
      </div>
    </div>
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">Frequently Asked Questions</h2>

      <div className="space-y-4">
        {faqData.map((faq, index) => (
          <div key={index} className="border-b border-gray-300 pb-4">
            <div
              className="flex items-center justify-between cursor-pointer"
              onClick={() => toggleAnswer(index)}
            >
              <h3 className="text-xl font-semibold text-gray-800">{faq.question}</h3>
              <span className="text-orange-500 text-xl">{activeQuestion === index ? '-' : '+'}</span>
            </div>
            {activeQuestion === index && (
              <p className="mt-2 text-gray-600">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
    <div className="bg-gray-100 py-16">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12 px-6">
        <div className="flex-1 text-center md:text-left">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Are you a Dog Walker?</h2>
          <p className="text-xl text-gray-600 mb-6">
            Discover the many benefits ThePetNest can offer you. Join our community of dedicated and professional dog walkers.
          </p>
          <a href="/learn-more" className="bg-orange-500 text-white py-2 px-6 rounded-lg text-lg font-semibold hover:bg-orange-600 transition">
            Learn More
          </a>
        </div>

        <div className="flex-1">
          <img
            src="//dm6g3jbka53hp.cloudfront.net/static-images/dog-walking_areyouadogwalker-section_foreground-image.svg" 
            alt="Dog Walker"
            className="rounded-lg shadow-lg w-full h-auto object-cover ml-14"
          />
        </div>
      </div>
    </div>
    <div className="bg-gray-100 py-16">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-center text-3xl font-bold text-gray-800 mb-8">
          Dog Walking Services in Major Cities
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 cursor-pointer">
          {cities.map((city, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center"
            >
              <div className="text-4xl mb-4">{city.icon}</div>
              <h3 className="font-semibold text-lg text-gray-800">{city.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
        </div>
    )
}

export default DogWalking
